export enum TechChoiceIdx {
  JAVASCRIPT = 0,
  TYPESCRIPT = 1,
  PYTHON = 2,
  JAVA = 3,
  C = 4,
  CPP = 5,
  CSHARP = 6,
  GO = 7,
  RUST = 8,
  PHP = 9,
  RUBY = 10,
  SWIFT = 11,
  DART = 12,
  BASH = 13,
  REACT = 14,
  ANGULAR = 15,
  VUE = 16,
  NEXT = 17,
  NEST = 18,
  NODE = 19,
  DJANGO = 20,
  SPRING = 21,
  RAILS = 22,
  LARAVEL = 23,
  DOTNET = 24,
  GIN = 25,
}
